import React from "react";
import BackgroundImage from "src/components/backgroundImage/backgroundImage.v1";
import Icon from "src/components/icon";

export default class YoutubeFacade extends React.Component<TVideoComponentProps> {

    static getId(src: string = "") {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
        const match = src.match(regExp);
        if (match && match[2].length == 11) { return match[2]; }
        return "";
    }

    render(): React.ReactNode {
        const id = YoutubeFacade.getId(this.props.src);
        const aspect = this.props.asBackground ? '' : 'aspect-[16/9]';
        return <div className={`w-full h-full ${aspect} relative cursor-pointer`}>
            <BackgroundImage mobileContain className="h-full w-full" src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} />
            <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                <Icon className="w-20 h-20 text-[#ff0000]" icon="YoutubeFilled" />
            </div>
        </div>
    }
}